//fix device issues
//This fixes an issue with Samsung devices incorrectly calling document.getElementsByClassName.ToString
Function.prototype.ToString = function () {
    return this.toString();
};

(function() {
    const fnName = document.currentScript.src.split('/').pop().replace(/\..*?js$/, '');
    window[fnName] = function(fpConfig, fpUtil, fpConstants, fpService, fpUi) {
        delete window[fnName];
        //create project level variables for commonly used features
        var fp = window.fp,
            $ = fp.$,
            jQuery = fp.$,
            _ = fp._,
            dateFns = fp.dateFns,
            jss = fp.jss,
            NProgress = fp.NProgress,
            oldNProgress = window.NProgress,
            showdown = fp.showdown,
            oldShowdown = window.showdown,
            S = fp.S,
            oldS = window.S,
            numeral = fp.numeral,
            oldNumeral = window.numeral,
            Lockr = fp.Lockr,
            oldLockr = window.Lockr,
            bugsnag = fp.bugsnag,
            oldBugsnag = window.bugsnag;

        //set up a way to access fp object from dev environment
        if(fp.isDev()) window._fp = fp;
        //if(!fp.isProd()) window._fp = fp;

        //removeIf(!debug)

        //fp.log('Freshop Debug Mode: true');
        //window._fp = fp;

        //endRemoveIf(!debug)